import { Navigate } from "react-router-dom";
import useAuth from "../custom-hooks/useAuth";

const AuthGuard = ({ children }: any) => {
  const contextData = useAuth();
  return (
    <>
      {(contextData?.cookie?.access_token_demo && contextData?.cookie?.refresh_token_demo) ? (
        children
      ) : (
        <Navigate to="/login" replace={true} />
      )}
    </>
  );
};
export default AuthGuard;
